import { usePathname } from 'next/navigation';
import { useCallback, useEffect, useState } from 'react';

import { type UserSession, userSession } from '@/lib/auth/session';
import { sessionEvents } from '@/lib/eventEmitters/sessionEvents';

export const useSession = () => {
  const [sessionData, setSessionData] = useState<UserSession | null>(null);
  const pathname = usePathname();

  const checkSession = useCallback(async () => {
    const user = await userSession();
    setSessionData(user ?? null);
  }, []);

  useEffect(() => {
    checkSession(); // Vérifie la session au montage et à chaque changement d'URL

    // Écoute les événements de session pour mettre à jour en temps réel
    sessionEvents.on('sessionChange', checkSession);

    return () => {
      sessionEvents.off('sessionChange', checkSession);
    };
  }, [checkSession, pathname]);

  return { isLoggedIn: !!sessionData, sessionData };
};
